import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { AbstractService } from '@core/http/abstract.service';

import { ApiResponse, MessageType } from './chat.entity';

@Injectable({
  providedIn: 'root'
})
export class ChatService extends AbstractService {
  protected override prefix = '/chat';

  getMessages(locale: string|null, roomId: number|null): Observable<ApiResponse.MessagesHistory> {
    if(null === locale && null === roomId) {
      throw Error('locale or roomId must be specified');
    }

    return this.get<ApiResponse.MessagesHistory>('/messages', { locale, roomId });
  }

  sendMessage(
    type: MessageType,
    content: any,
    roomId: number,
    taggedUserId: number|null
  ): Observable<ApiResponse.SendMessage> {
    const params = {
      content,
      type,
      roomId,
      taggedUserId
    };

    return this.post<ApiResponse.SendMessage>(
      '/messages/send',
      params,
      { throwError: true }
    );
  }

  deleteMessage(id: number): Observable<void> {
    return this.delete<void>(`/messages/${ id }`, { throwError: true });
  }

  pinMessage(id: number): Observable<void> {
    return this.post<void>(`/messages/${ id }/pin`, {}, { throwError: true });
  }

  unpinMessage(id: number): Observable<void> {
    return this.post<void>(`/messages/${ id }/unpin`, {}, { throwError: true });
  }
}